import React from "react";
import "./DeleteModal.css"; // optional for styles

const DeleteModal = ({ isOpen, onConfirm, onCancel , title ,message}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="delete-modal">
        <h2>{title}</h2>
        <p>{message}</p>
        <div className="modal-actions">
          {/* <button className="primary_btn" onClick={onConfirm}>
            Yes
          </button>
          <button className="cancel_btn" onClick={onCancel}>
            No
          </button> */}
          <button className="delete_approve_btn" onClick={onConfirm}>
            Yes, I’m Sure
          </button>
          <button className="delete_reject_btn" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
